import { Component, Input } from '@angular/core';

import { IWebcastTranslationKeys } from 'rev-shared/webcast/IWebcastTranslationKeys';

import { WebcastModel } from 'rev-portal/scheduledEvents/webcast/model/WebcastModel';

import styles from './WebcastStartAndEndMessage.Component.module.less';

@Component({
	selector: 'webcast-start-and-end-message',
	templateUrl: './WebcastStartAndEndMessage.Component.html',
	standalone: false
})
export class WebcastStartAndEndMessageComponent {
	@Input() public webcast: WebcastModel;
	@Input() public translationKeys: IWebcastTranslationKeys;

	public readonly styles = styles;
}
